(function () {
  'use strict';

  if (window.__cartBundleUpsellLoaded) return;
  window.__cartBundleUpsellLoaded = true;

  var WIDGET_SELECTOR = '[data-cart-bundle-upsell]';
  if (!document.querySelector(WIDGET_SELECTOR)) return;

  var FREE_PROP = '_bundle_free';
  var BUNDLE_PROP = 'Bundle';

  // Tier config injected by the section (from bundle_config metaobjects),
  // with a hardcoded fallback that matches the store's bundle discounts.
  var cfg = window.__cartBundleConfig || {};
  var tiers = (cfg.tiers && cfg.tiers.length)
    ? cfg.tiers.slice()
    : [{ paid: 2, free: 1 }, { paid: 3, free: 2 }];
  tiers = tiers.filter(function (t) { return t && t.paid > 0; });
  if (cfg.buy3Get2Enabled === false) {
    tiers = tiers.filter(function (t) { return t.paid !== 3; });
  }
  tiers.sort(function (a, b) { return a.paid - b.paid; });

  var allProducts = null;
  var productsPromise = null;
  var busy = false;

  function widgets() {
    return Array.prototype.slice.call(document.querySelectorAll(WIDGET_SELECTOR));
  }

  function innerOf(widget) {
    return widget.querySelector('.cart-bundle-upsell__inner');
  }

  function label(tier) {
    return 'Buy ' + tier.paid + ' Get ' + tier.free + ' Free';
  }

  function getCart() {
    return fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function isFreeItem(item) {
    var p = item.properties || {};
    return p[FREE_PROP] === 'true' || p[FREE_PROP] === true;
  }

  // A "completed bundle" is a multi-buy bundle added via the builders
  // (label like "Buy 2 Get 1 Free"). Single bottles tagged "1 Bottle" are
  // NOT completed bundles and should count as paid singles.
  function isCompletedBundleItem(item) {
    var p = item.properties || {};
    var b = p[BUNDLE_PROP];
    if (!b) return false;
    return /get/i.test(String(b));
  }

  // A "Mix Your Own" custom blend is added by the mix-your-own builder with a
  // unique "Custom SKU" property (prefixed "CUSTOM-"). These are a separate
  // product category and must be fully excluded from the bundle: they never
  // count toward the threshold and are never treated as a free reward.
  function isMixYourOwnItem(item) {
    var p = item.properties || {};
    var sku = p['Custom SKU'];
    if (typeof sku === 'string' && sku.indexOf('CUSTOM-') === 0) return true;
    // Fallback: identify by the blend-specific properties.
    return !!(p['Blend Name'] && p['Scent A'] && p['Scent B']);
  }

  // paid = organically-added individual perfumes (plain items or "1 Bottle" tier).
  // free = items this widget added (_bundle_free).
  // completed multi-buy bundles and Mix Your Own blends are ignored.
  function classify(cart) {
    var paid = 0;
    var free = 0;
    cart.items.forEach(function (item) {
      if (isFreeItem(item)) {
        free += item.quantity;
      } else if (isCompletedBundleItem(item)) {
        // ignore
      } else if (isMixYourOwnItem(item)) {
        // Mix Your Own is a separate category — never counts toward the bundle.
      } else {
        paid += item.quantity;
      }
    });
    return { paid: paid, free: free };
  }

  var cycleSize = 0;
  var freePositions = [];
  tiers.forEach(function (t) {
    var total = t.paid + t.free;
    if (total > cycleSize) cycleSize = total;
    if (freePositions.indexOf(total - 1) === -1) freePositions.push(total - 1);
  });
  freePositions.sort(function (a, b) { return a - b; });

  function tierAtPosition(pos) {
    var match = null;
    tiers.forEach(function (t) {
      if (t.paid + t.free - 1 === pos) match = t;
    });
    return match;
  }

  function entitledFree(total) {
    var count = 0;
    for (var i = 0; i < total; i++) {
      if (freePositions.indexOf(i % cycleSize) !== -1) count++;
    }
    return count;
  }

  function bottlesToNextFree(total) {
    var pos = total % cycleSize;
    for (var i = 0; i < freePositions.length; i++) {
      if (freePositions[i] > pos) return { more: freePositions[i] - pos, tier: tierAtPosition(freePositions[i]) };
    }
    return { more: cycleSize - pos + freePositions[0], tier: tierAtPosition(freePositions[0]) };
  }

  function fetchAllProducts() {
    if (productsPromise) return productsPromise;
    productsPromise = new Promise(function (resolve) {
      var acc = [];
      function grab(page) {
        fetch('/collections/all/products.json?limit=250&page=' + page, {
          headers: { Accept: 'application/json' }
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var list = (data && data.products) || [];
            acc = acc.concat(list);
            if (list.length === 250 && page < 4) {
              grab(page + 1);
            } else {
              allProducts = acc.filter(function (p) {
                return p.variants && p.variants.some(function (v) { return v.available; });
              });
              resolve(allProducts);
            }
          })
          .catch(function () { resolve(acc); });
      }
      grab(1);
    });
    return productsPromise;
  }

  function firstAvailableVariant(product) {
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return product.variants[i];
    }
    return product.variants[0];
  }

  function getInspiredByLabel(product) {
    var tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
    for (var i = 0; i < tags.length; i++) {
      var tag = String(tags[i]).trim().toLowerCase();
      if (tag.indexOf('inspired_by_') === 0) {
        var raw = tag.substring('inspired_by_'.length);
        var label = raw.replace(/_/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
        if (label) return label;
      }
    }
    return product.title;
  }

  function buildCustomOption(product, index) {
    var inspiredBy = getInspiredByLabel(product);
    var hasInspiredBy = inspiredBy !== product.title;
    var v = firstAvailableVariant(product);
    var item = document.createElement('div');
    item.className = 'mix-custom-select__option';
    item.dataset.value = product.title;
    item.dataset.index = index;
    item.dataset.variantId = v.id;
    var nameEl = document.createElement('div');
    nameEl.className = 'mix-custom-select__option-name';
    nameEl.textContent = product.title;
    item.appendChild(nameEl);
    if (hasInspiredBy) {
      var subEl = document.createElement('div');
      subEl.className = 'mix-custom-select__option-sub';
      subEl.textContent = 'Inspired by ' + inspiredBy;
      item.appendChild(subEl);
    }
    return item;
  }

  function makeCustomSelectEl() {
    var customEl = document.createElement('div');
    customEl.className = 'mix-custom-select';

    var trigger = document.createElement('div');
    trigger.className = 'mix-custom-select__trigger';
    var triggerText = document.createElement('div');
    triggerText.className = 'mix-custom-select__trigger-text';
    var placeholder = document.createElement('span');
    placeholder.className = 'mix-custom-select__placeholder';
    placeholder.textContent = 'Choose a perfume...';
    triggerText.appendChild(placeholder);
    var arrowSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    arrowSvg.setAttribute('class', 'mix-custom-select__arrow');
    arrowSvg.setAttribute('width', '12');
    arrowSvg.setAttribute('height', '8');
    arrowSvg.setAttribute('viewBox', '0 0 12 8');
    var arrowPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    arrowPath.setAttribute('d', 'M1 1.5l5 5 5-5');
    arrowPath.setAttribute('stroke', 'currentColor');
    arrowPath.setAttribute('stroke-width', '1.5');
    arrowPath.setAttribute('fill', 'none');
    arrowPath.setAttribute('stroke-linecap', 'round');
    arrowSvg.appendChild(arrowPath);
    trigger.appendChild(triggerText);
    trigger.appendChild(arrowSvg);

    var dropdown = document.createElement('div');
    dropdown.className = 'mix-custom-select__dropdown';
    var searchWrap = document.createElement('div');
    searchWrap.className = 'mix-custom-select__search';
    var searchInput = document.createElement('input');
    searchInput.className = 'mix-custom-select__search-input';
    searchInput.type = 'text';
    searchInput.placeholder = 'Search scents...';
    searchInput.setAttribute('autocomplete', 'off');
    searchWrap.appendChild(searchInput);
    dropdown.appendChild(searchWrap);

    allProducts.forEach(function (product, idx) {
      dropdown.appendChild(buildCustomOption(product, idx));
    });

    customEl.appendChild(trigger);
    customEl.appendChild(dropdown);
    return customEl;
  }

  function setupCustomSelect(widget, customEl, onChange) {
    var trigger = customEl.querySelector('.mix-custom-select__trigger');
    var dropdown = customEl.querySelector('.mix-custom-select__dropdown');
    var triggerText = customEl.querySelector('.mix-custom-select__trigger-text');
    var searchInput = customEl.querySelector('.mix-custom-select__search-input');

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = customEl.classList.contains('open');
      widget.querySelectorAll('.mix-custom-select.open').forEach(function (el) {
        el.classList.remove('open');
      });
      if (!isOpen) {
        customEl.classList.add('open');
        setTimeout(function () { searchInput.focus(); }, 50);
      }
    });

    dropdown.addEventListener('click', function (e) {
      e.stopPropagation();
      var option = e.target.closest('.mix-custom-select__option');
      if (!option) return;
      customEl.dataset.value = option.dataset.value;
      customEl.dataset.variantId = option.dataset.variantId;
      dropdown.querySelectorAll('.mix-custom-select__option').forEach(function (el) {
        el.classList.remove('selected');
      });
      option.classList.add('selected');
      var name = option.querySelector('.mix-custom-select__option-name').textContent;
      var subEl = option.querySelector('.mix-custom-select__option-sub');
      triggerText.innerHTML = '';
      var nameDisplay = document.createElement('div');
      nameDisplay.className = 'mix-custom-select__selected-name';
      nameDisplay.textContent = name;
      triggerText.appendChild(nameDisplay);
      if (subEl) {
        var subDisplay = document.createElement('div');
        subDisplay.className = 'mix-custom-select__selected-sub';
        subDisplay.textContent = subEl.textContent;
        triggerText.appendChild(subDisplay);
      }
      searchInput.value = '';
      dropdown.querySelectorAll('.mix-custom-select__option').forEach(function (opt) {
        opt.style.display = '';
      });
      customEl.classList.remove('open');
      if (typeof onChange === 'function') onChange();
    });

    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim().toLowerCase();
      dropdown.querySelectorAll('.mix-custom-select__option').forEach(function (opt) {
        var name = opt.querySelector('.mix-custom-select__option-name').textContent.toLowerCase();
        var subEl = opt.querySelector('.mix-custom-select__option-sub');
        var sub = subEl ? subEl.textContent.toLowerCase() : '';
        opt.style.display = (query === '' || name.indexOf(query) !== -1 || sub.indexOf(query) !== -1) ? '' : 'none';
      });
    });
  }

  function hide(widget) {
    widget.hidden = true;
    widget.classList.remove('cart-bundle-upsell--nudge');
    innerOf(widget).innerHTML = '';
  }

  function hideAll() {
    widgets().forEach(hide);
  }

  function sectionIds() {
    var ids = [];
    if (document.querySelector('#CartDrawer .drawer__inner')) ids.push('cart-drawer');
    var itemsEl = document.getElementById('main-cart-items');
    if (itemsEl) ids.push(itemsEl.dataset.id || 'main-cart-items');
    var footerEl = document.getElementById('main-cart-footer');
    if (footerEl) ids.push(footerEl.dataset.id || 'main-cart-footer');
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    return ids;
  }

  function applySections(sections) {
    if (!sections) return;
    var parser = new DOMParser();
    function parsed(id) {
      return id && sections[id] ? parser.parseFromString(sections[id], 'text/html') : null;
    }

    var drawerDoc = parsed('cart-drawer');
    var drawerInner = document.querySelector('#CartDrawer .drawer__inner');
    if (drawerDoc && drawerInner) {
      var newInner = drawerDoc.querySelector('.drawer__inner');
      if (newInner) drawerInner.innerHTML = newInner.innerHTML;
      if (!drawerDoc.querySelector('cart-drawer-items.is-empty')) {
        drawerInner.classList.remove('is-empty');
        var drawerEl = document.querySelector('cart-drawer');
        if (drawerEl) drawerEl.classList.remove('is-empty');
      }
    }

    var itemsEl = document.getElementById('main-cart-items');
    var itemsDoc = itemsEl ? parsed(itemsEl.dataset.id || 'main-cart-items') : null;
    if (itemsDoc) {
      var newItems = itemsDoc.querySelector('.js-contents');
      var curItems = itemsEl.querySelector('.js-contents');
      if (newItems && curItems) curItems.innerHTML = newItems.innerHTML;
    }

    var footerEl = document.getElementById('main-cart-footer');
    var footerDoc = footerEl ? parsed(footerEl.dataset.id || 'main-cart-footer') : null;
    if (footerDoc) {
      var newFooter = footerDoc.querySelector('.js-contents');
      var curFooter = footerEl.querySelector('.js-contents');
      if (newFooter && curFooter) curFooter.innerHTML = newFooter.innerHTML;
    }

    var bubbleDoc = parsed('cart-icon-bubble');
    var curBubble = document.getElementById('cart-icon-bubble');
    if (bubbleDoc && curBubble) {
      var newBubble = bubbleDoc.querySelector('.shopify-section');
      if (newBubble) curBubble.innerHTML = newBubble.innerHTML;
    }

    var cartItemsEl = document.querySelector('cart-items');
    if (cartItemsEl) cartItemsEl.classList.remove('is-empty');
  }

  function fetchSections(ids) {
    if (!ids.length) return Promise.resolve(null);
    return fetch(window.location.pathname + '?sections=' + ids.join(','), {
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function refreshDrawerIfStale(cart) {
    var drawerWidget = document.getElementById('CartDrawer-BundleUpsell');
    if (!drawerWidget) return Promise.resolve();
    var rendered = parseInt(drawerWidget.dataset.itemCount, 10);
    if (isNaN(rendered) || rendered === cart.item_count) return Promise.resolve();
    return fetchSections(['cart-drawer']).then(applySections);
  }

  function removeExcessFree(cart, count) {
    var freeItems = cart.items.filter(isFreeItem);
    var toRemove = count;
    var chain = Promise.resolve();
    freeItems.forEach(function (item) {
      if (toRemove <= 0) return;
      var reduce = Math.min(item.quantity, toRemove);
      var newQty = item.quantity - reduce;
      toRemove -= reduce;
      chain = chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: newQty })
        });
      });
    });
    return chain
      .then(function () { return fetchSections(sectionIds()); })
      .then(applySections);
  }

  function renderPicker(widget, missing, tier) {
    widget.classList.remove('cart-bundle-upsell--nudge');
    fetchAllProducts().then(function () {
      if (!allProducts || !allProducts.length) { hide(widget); return; }
      if (!document.body.contains(widget)) return;

      var inner = innerOf(widget);
      var word = missing > 1 ? missing + ' free perfumes' : 'a free perfume';
      inner.innerHTML =
        '<h3 class="cart-bundle-upsell__title">You’ve unlocked ' + word + '!</h3>' +
        '<p class="cart-bundle-upsell__subtitle">Your cart qualifies for <strong>' + label(tier) +
          '</strong>. Pick your free scent' + (missing > 1 ? 's' : '') + ' below to get the bundle price.</p>' +
        '<div class="cart-bundle-upsell__selects"></div>' +
        '<button type="button" class="cart-bundle-upsell__btn" data-confirm disabled>' +
          'Add my free perfume' + (missing > 1 ? 's' : '') +
        '</button>';

      var selectsWrap = inner.querySelector('.cart-bundle-upsell__selects');
      var confirm = inner.querySelector('[data-confirm]');
      var customSelects = [];

      function validate() {
        var allSet = customSelects.every(function (el) { return !!el.dataset.variantId; });
        confirm.disabled = !allSet;
      }

      for (var i = 0; i < missing; i++) {
        var row = document.createElement('div');
        row.className = 'cart-bundle-upsell__select-row';
        if (missing > 1) {
          var lbl = document.createElement('span');
          lbl.className = 'cart-bundle-upsell__select-label';
          lbl.textContent = 'Free #' + (i + 1);
          row.appendChild(lbl);
        }
        var customEl = makeCustomSelectEl();
        setupCustomSelect(widget, customEl, validate);
        row.appendChild(customEl);
        selectsWrap.appendChild(row);
        customSelects.push(customEl);
      }

      widget.hidden = false;

      confirm.addEventListener('click', function () {
        if (busy) return;
        busy = true;
        confirm.classList.add('is-loading');
        confirm.textContent = 'Adding...';

        var items = [];
        customSelects.forEach(function (el) {
          if (!el.dataset.variantId) return;
          items.push({
            id: parseInt(el.dataset.variantId, 10),
            quantity: 1,
            properties: (function () {
              var props = { Scent: el.dataset.value || '' };
              props[FREE_PROP] = 'true';
              props[BUNDLE_PROP] = label(tier);
              return props;
            })()
          });
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: items,
            sections: sectionIds().join(','),
            sections_url: window.location.pathname
          })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function (data) { applySections(data && data.sections); })
          .then(function () { busy = false; evaluate(); })
          .catch(function () {
            busy = false;
            confirm.classList.remove('is-loading');
            confirm.textContent = 'Something went wrong — try again';
          });
      });
    });
  }

  function renderNudge(widget, moreNeeded, unlockText) {
    widget.classList.add('cart-bundle-upsell--nudge');
    var bottleWord = moreNeeded > 1 ? moreNeeded + ' more bottles' : '1 more bottle';
    innerOf(widget).innerHTML =
      '<h3 class="cart-bundle-upsell__title">Almost there!</h3>' +
      '<p class="cart-bundle-upsell__subtitle">Add <strong>' + bottleWord +
        '</strong> to unlock <strong>' + unlockText + '</strong>.</p>' +
      '<a class="cart-bundle-upsell__btn" href="/collections/all">Shop perfumes</a>';
    widget.hidden = false;
  }

  function evaluate() {
    if (busy) return;
    if (!widgets().length) return;
    getCart()
      .then(function (cart) {
        return refreshDrawerIfStale(cart).then(function () { return cart; });
      })
      .then(function (cart) {
        var c = classify(cart);
        var total = c.paid + c.free;
        var entitled = cycleSize > 0 ? entitledFree(total) : 0;

        if (c.free > entitled) {
          busy = true;
          removeExcessFree(cart, c.free - entitled).then(function () {
            busy = false;
            evaluate();
          });
          return;
        }

        var pos = cycleSize > 0 ? total % cycleSize : 0;
        var pickTier = total > 0 ? tierAtPosition(pos) : null;
        var next = total > 0 && cycleSize > 0 ? bottlesToNextFree(total) : null;
        var firstCycle = total < cycleSize;

        widgets().forEach(function (widget) {
          if (pickTier) {
            renderPicker(widget, 1, pickTier);
          } else if (next && next.tier) {
            renderNudge(widget, next.more, firstCycle ? label(next.tier) : 'another free perfume');
          } else {
            hide(widget);
          }
        });
      })
      .catch(hideAll);
  }

  // Close any open custom dropdown when clicking outside of it.
  document.addEventListener('click', function () {
    document.querySelectorAll(WIDGET_SELECTOR + ' .mix-custom-select.open').forEach(function (el) {
      el.classList.remove('open');
    });
  });

  // Re-evaluate whenever the native cart updates (quantity change / remove).
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'cart-bundle-upsell') return;
      evaluate();
    });
  }

  var drawerEl = document.querySelector('cart-drawer');
  if (drawerEl && typeof MutationObserver !== 'undefined') {
    var wasActive = drawerEl.classList.contains('active');
    new MutationObserver(function () {
      var isActive = drawerEl.classList.contains('active');
      if (isActive && !wasActive) evaluate();
      wasActive = isActive;
    }).observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
  }

  evaluate();
})();
